import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";

import {Navigate} from "react-router";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";

import {traerInformePagos} from "../../api/informes.service";
import {
    getAsociados, obtenerAnioLiquidacionesPorCliente,
    obtenerLiquidacionesPorCliente, obtenerMesLiquidacionesPorCliente
} from "../../api/liquidacionDeduccion.service";
import {UseLoader} from "../../hooks/useLoader";
import {Toast} from "primereact/toast";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerGroupForm} from "../Containers/ContainerGroupForm";

import {ContainerPrint} from "../PagoDeduccion/ContainerPrint";
import {useReactToPrint} from "react-to-print";
import {TabPanel, TabView} from "primereact/tabview";
import {InformepagosTotal} from "../../pages/informePago/components/InformepagosTotal";
import {confirmDialog} from "primereact/confirmdialog";


export const InformePagos = () => {
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const componentRef = useRef(null);

    const [clientes, setClientes] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: ""
    });
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [fechaLiquidaciones, setFechaLiquidaciones] = useState([]);
    const [anioLiquidaciones, setAnioLiquidaciones] = useState([]);
    const [mesLiquidaciones, setMesLiquidaciones] = useState([]);

    const initParams = {
        cliente_id: '',
        fecha: '',
        anio: '',
        mes: ''
    };
    const [field, setField] = useState(initParams);

    /* variables info pagos */

    const [dataPagos, setDataPagos] = useState([]);

    const [prestaciones, setPrestaciones]=  useState([]);

    const handlePrint = useReactToPrint({
        documentTitle: "Pago Compensación TOA",
        content: () => componentRef.current,
        onBeforePrint:() => handleLoad(true),
        onAfterPrint: () => handleLoad(false),
    });

    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);

/*    useEffect(() => {
        fechaLiquidaciones.map((obj) => {
            if (obj.fecha === field.fecha) {
                setField({...field, anio: obj.anio, mes: obj.mes});
            }
        })
    }, [field.fecha]);*/

    const onChangeFecha = e => {
        setMesLiquidaciones([]);
        setField({...field, fecha: e.target.value})

       /* if (field.cliente_id === "" || e.target.value === '') {
            setAnioLiquidaciones([]);
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)

        const payload = {
            cliente_id: field.cliente_id,
            fecha: e.target.value
        }
        obtenerAnioLiquidacionesPorCliente(payload).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setAnioLiquidaciones([]);
                setMesLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setAnioLiquidaciones(r.data)
        })*/
    }

   /* const onChangeAnio = e => {

        setField({...field, anio: e.target.value})
        
        if (field.cliente_id === "" || field.fecha === ''  || e.target.value === '') {
            setMesLiquidaciones([]);
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }
        handleLoad(true)
        const payload = {
            cliente_id: field.cliente_id,
            fecha: field.fecha,
            anio: e.target.value
        }
        obtenerMesLiquidacionesPorCliente(payload).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setMesLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setMesLiquidaciones(r.data)
        })

    }*/


    const confirmFecha = (id) => {
        confirmDialog({
            message: 'Filtrar ultimas 3 fechas',
            header: 'confirmacion',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: () => acceptFunc(id),
            reject: () => rejectFunc(id)
        });
    }

    const acceptFunc = (id) => {
        traerFechaLiquidacion(id, 'S');
    }

    const rejectFunc = (id) => {
        traerFechaLiquidacion(id, 'N');
    }

    const traerFechaLiquidacion = (id, filtrar) => {

        setField({...field, cliente_id: id,  fecha: "", anio: '', mes: ''})
        handleLoad(true);
        setMesLiquidaciones([]);
        setAnioLiquidaciones([]);
        obtenerLiquidacionesPorCliente(id, filtrar).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setDataPagos([]);
                setPrestaciones([]);
                setFechaLiquidaciones([]);
                setMesLiquidaciones([]);
                setAnioLiquidaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;

            }
            setFechaLiquidaciones(r.data)
        }).catch(r =>  handleLoad(false))

    }
    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }
    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const reloadInformespagos = () => {
        if (field.cliente_id === "" ||field.fecha === '') {
            toast.current?.show({severity: 'error', summary: 'Alerta', detail: "Validar campos", life: 3000});
            return;
        }

        handleLoad(true)


        /** informes info */
        traerInformePagos(field).then(r => {
            handleLoad(false)
            if (r.estado !== 200) {
                setDataPagos([]);
                setPrestaciones([]);
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: r.mensaje, life: 3000});
                return;
            }

            if (r.data.length>0) {
                setDataPagos( r.data);
                setPrestaciones(r.prestaciones);
            }

        }).catch(r => handleLoad(false))

    }

    const buscarLiquidaciones = (e) => {
        e.preventDefault();
        setActiveIndex(0);
        reloadInformespagos();
    }


    return (

        <TabView  activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel   header="Informe pagos por asociado">
                <ContainerTable>
                    {permisos.consultar ?  <div className="container-relative">
                        <Toast ref={toast}/>
                        {dataPagos.length > 0 && <div className="my-4 lg:w-4/12 m-auto ">
                            <button
                                className="secundary-color-btn btn w-full"
                                type="button"
                                onClick={handlePrint}
                            >
                                Imprimir
                            </button>
                        </div>}
                        <ContainerTable>
                            <div className="px-2">
                                <div className=" flex flex-wrap items-center  p-4 primary-color">
                                    {permisos.consultar === 1 && clientes.length > 0 ?
                                        <div className=" mt-2 relative lg:w-4/12 px-4">
                                            <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                                          style={{"width": "100%"}}
                                                          completeMethod={searchCliente}
                                                          placeholder="Buscador de asociados"
                                                          size="30"
                                                          field="nombre" dropdown itemTemplate={itemTemplate}
                                                          onSelect={(e) => confirmFecha(e.value.id)}
                                                          onChange={(e) => setSelectedcliente(e.value)}/>
                                        </div>
                                        : ""}
                                    <div className=" mt-2 relative lg:w-8/12 px-4">
                                        <form onSubmit={buscarLiquidaciones}>
                                            <div className="row">

                                                {fechaLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-3/12">
                                                    <label
                                                        className="label-form text-white"
                                                        htmlFor="fecha"
                                                    >
                                                        Fecha liquidación *
                                                    </label>
                                                    <select value={field.fecha} name="periodo"
                                                            className="form-input"
                                                            onChange={(e) => setField({...field, fecha: e.target.value})}
                                                            id="fecha">
                                                        <option value="">...</option>
                                                        {fechaLiquidaciones.map((p, i) => <option key={i}
                                                                                                  value={p.fecha}>{p.fecha}</option>)}
                                                    </select>

                                                </ContainerGroupForm>}
                                        {/*        {anioLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-2/12">
                                                    <label
                                                        className="label-form text-white"
                                                        htmlFor="fecha"
                                                    >
                                                        Año  *
                                                    </label>
                                                    <select value={field.anio} name="anio"
                                                            className="form-input"
                                                            onChange={(e) => onChangeAnio(e)}
                                                            id="anio">
                                                        <option value="">...</option>
                                                        {anioLiquidaciones.map((p, i) => <option key={i}
                                                                                                  value={p.anio}>{p.anio}</option>)}
                                                    </select>

                                                </ContainerGroupForm>}
                                                {mesLiquidaciones.length > 0 && <ContainerGroupForm width="lg:w-2/12">
                                                    <label
                                                        className="label-form text-white"
                                                        htmlFor="fecha"
                                                    >
                                                        Mes *
                                                    </label>
                                                    <select value={field.mes} name="periodo"
                                                            className="form-input"
                                                            onChange={(e) => setField({...field, mes: e.target.value})}
                                                            id="fecha">
                                                        <option value="">...</option>
                                                        {mesLiquidaciones.map((p, i) => <option key={i}
                                                                                                  value={p.mes}>{p.mes}</option>)}
                                                    </select>

                                                </ContainerGroupForm>}*/}
                                                <ContainerGroupForm width="lg:w-4/12">
                                                    <div className="mt-6 relative w-full px-4">
                                                        <button
                                                            className="warning-color-btn btn w-full"
                                                            type="submit"
                                                        >
                                                            Buscar
                                                        </button>
                                                    </div>



                                                </ContainerGroupForm>
                                            </div>
                                        </form>

                                    </div>

                                </div>

                            </div>

                            {dataPagos.length > 0 &&  <ContainerPrint
                                ref={componentRef}
                                datapago={dataPagos}
                                prestaciones={prestaciones}
                            />}
                        </ContainerTable>

                    </div>: <Navigate to="/home"/>}
                </ContainerTable>
            </TabPanel>
            <TabPanel header="Informe de pagos">
                <ContainerTable>
                    <ContainerTable>
                        {permisos.consultar? <InformepagosTotal /> : <Navigate to="/home" />}
                    </ContainerTable>

                </ContainerTable>
            </TabPanel>

        </TabView>


    );
}
